module.exports = __webpack_public_path__ + "static/media/codechef_logo.60655adc.jpg";